import { queryOptions } from '@tanstack/react-query'

import { cardfileApi } from './cardfileApi'

const CARDFILE_STALE_TIME = 10 * 60 * 1000

export const cardfileQueries = {
  all: () => ['cardfile'] as const,
  info: (vatNumber: string) =>
    queryOptions({
      queryKey: [...cardfileQueries.all(), 'info', vatNumber],
      queryFn: ({ signal }) => cardfileApi.getInfo(vatNumber, { signal }),
      staleTime: CARDFILE_STALE_TIME,
    }),
}
